import styled from 'styled-components';
import VizExLoadingSpinner from 'visitor-ui-component-library/loading/VizExLoadingSpinner';
import { jsx as _jsx } from "react/jsx-runtime";
const LoadingStateWrapper = styled.div.withConfig({
  displayName: "LoadingState__LoadingStateWrapper",
  componentId: "thejlf-0"
})(["height:100%;"]);
export default function LoadingState() {
  return /*#__PURE__*/_jsx(LoadingStateWrapper, {
    children: /*#__PURE__*/_jsx(VizExLoadingSpinner, {
      grow: true
    })
  });
}
LoadingState.displayName = 'LoadingState';